import React from "react";
import { Select } from "antd";

function HexSelect({
  label,
  required = false,
  value,
  onChange,
  options = [],
  placeholder = "---Select----",
  disabled = false,
  showSearch = false,
  allowClear = false,
  creatable = false,
  className = "",
  wrapperClassName = "",
  status,
  ...rest
}) {
  const labelClass = "text-xs font-bold text-slate-500 uppercase tracking-wider";

  return (
    <div className={`flex flex-col gap-1.5 ${wrapperClassName}`}>
      {label && (
        <label className={labelClass}>
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      {creatable ? (

        <Select
style={{height:"38px"}}
          mode="tags"
          value={value ? [value] : []}
          onChange={(vals) => {
            const last = vals.length ? vals[vals.length - 1] : "";
            if (onChange) onChange(last);
          }}
          options={options}
          placeholder={placeholder}
          disabled={disabled}
          allowClear={allowClear}
          maxTagCount={1}
          className={`hex-select w-full ${className}`}
          status={status}
          {...rest}
        />
      ) : (
        <Select
style={{height:"38px"}}
          value={value === "" || value === undefined ? undefined : value}
          onChange={onChange}
          options={options}
          placeholder={placeholder}
          disabled={disabled}
          showSearch={showSearch}
          optionFilterProp="label"
          allowClear={allowClear}
          className={`hex-select w-full ${className}`}
          status={status}
          {...rest}
        />
      )}
    </div>
  );
}

export default HexSelect;
